var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainButton"},[_c('button',{on:{"click":function($event){return _vm.emitChange()}}},[_vm._v(_vm._s(this.cta))])])
}
var staticRenderFns = []

export { render, staticRenderFns }